<template>
  <div
    class="picker-item flex justify-center items-center"
    :class="{ active }"
    v-on="$listeners"
  >
    <span v-if="text">{{ text }}</span>
    <slot name="content"></slot>
  </div>
</template>
<script>
export default {
  name: 'PickerBtn',
  props: {
    text: String,
    active: Boolean,
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixins.scss';
@import '../styles/index.scss';
</style>
